<template>
  <div class="border-top">
    <ValidationObserver ref="formValidator" class="w-100">
      <form
        class="needs-validation"
        validate
        @submit.prevent="saveRejectEvaluation"
      >
        <div class="mt-4 w-50">
          <ValidationProvider
            v-slot="{ errors }"
            name="noAceptadaPor"
            rules="required"
          >
            <CustomDropDown
              id="ddlSelectedRejectType"
              v-model="evaluation.rejectionById"
              label="No aceptada por:"
              placeholder="Seleccione"
              required
              fieldkey="id"
              fieldname="name"
              :options="rejectTypeList"
              :error="errors[0]"
              :custom-error-msg="errorMsgs['noAceptadaPor']"
            />
          </ValidationProvider>
        </div>

        <div class="mt-4">
          <ValidationProvider
            v-slot="{ errors }"
            class="w-100"
            name="Comentario"
            rules="required"
          >
            <CustomTextArea
              v-show="true"
              id="txtRejectionComment"
              v-model="evaluation.rejectionComment"
              :placeholder="'Comentario...'"
              :maxlength="3000"
              :row="5"
              required
              :error="errors[0]"
              :custom-error-msg="errorMsgs['comentario']"
            />
          </ValidationProvider>
        </div>

        <div class="pb-4 pt-4 px-35 w-100 d-flex justify-content-end">
          <div class="group-1012 mr-2">
            <ActionButton
              id="modal-btn-cancelar"
              variant="outline-danger"
              type="button"
              i="fas fa-times-circle"
              @click="cancelRejectEvaluation"
            >
              Cancelar
            </ActionButton>
          </div>
          <div class="group-1012 mr-0">
            <ActionButton id="btnSaveReject" variant="success" type="submit">
              Guardar
            </ActionButton>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<style scoped>
* {
  text-align: left;
}

.rejectModal-modal .modal-dialog {
  max-width: 884px;
  width: 100%;
}
.rejectModal-modal .modal-dialog .modal-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 10px;
  height: 29px;
  padding-bottom: 0;
}
.rejectModal-modal .modal-dialog .modal-title span {
  font-size: 18px;
}
.rejectModal-modal .modal-dialog .modal-title-icon-container {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rejectModal-modal .modal-dialog .modal-title-icon-container i {
  font-size: 0.9rem;
}

.rejectModal-modal .modal-dialog .row {
  margin: 0px;
}
form {
  width: 100% !important;
}
.rejectModal-form .modal-body,
.rejectModal-form .modal-colum {
  display: flex;
}
.rejectModal-form .modal-body {
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rejectModal-form .modal-colum {
  width: 100%;
  max-width: 314px;
  flex-direction: column;
}
.rejectModal-form .modal-colum ul {
  list-style: none;
  padding: 5px 0 5px 0;
}
.rejectModal-form .modal-colum ul li {
  font-size: 14px;
  margin: 5px 0px;
  padding: 2px 15px;
  cursor: pointer;
}
.rejectModal-form .modal-colum ul li:hover,
.rejectModal-form .modal-colum ul li.addList {
  background-color: #2db782;
  color: #ffffff;
}
.rejectModal-form .modal-colum button {
  text-align: left;
  padding-left: 0px;
  color: #2db782;
  text-decoration: underline;
}
.rejectModal-form .modal-colum .tag-badge-title-info {
  padding-left: 15px;
  font-weight: 800;
  color: black;
}

.rejectModal-form .modal-left-col,
.rejectModal-form .modal-right-col {
  min-height: 217px;
  height: 100%;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  margin: 15px 0;
}
.rejectModal-form .center-column {
  justify-content: center;
  align-items: center;
}
.rejectModal-form .modal-center-col {
  max-width: 105px;
  width: 100%;
}
.rejectModal-form .modal-center-col button {
  width: 100%;
  height: 29px;
  margin: 25px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  color: #fff;
  font-weight: 800;
  text-decoration: none;
  background-color: #2db782;
  border: 0px;
}
.rejectModal-form .modal-center-col button:last-child {
  background-color: #c9545e;
}
.rejectModal-form .modal-center-col button i.fa-chevron-right {
  padding-left: 12px;
}
.rejectModal-form .modal-center-col button i.fa-chevron-left {
  padding-right: 6px;
}
.rejectModal-modal .modal-content {
  border-radius: 0px;
}
.rejectModal-form .modal-footer {
  border-top: 0px;
  padding-bottom: 30px;
  padding-right: 65px;
}
.rejectModal-form .modal-footer .footer-col {
  display: flex;
  justify-content: flex-end;
}
.rejectModal-form .modal-footer .footer-col button {
  font-size: 1rem;
  font-weight: 600;
  height: 43px;
}
.rejectModal-form .modal-footer .footer-col button.btn-cancel {
  margin-right: 15px;
  color: #c9545e;
  border-color: #c9545e;
  max-width: 124px;
  width: 100%;
}
.rejectModal-form .modal-footer .footer-col button.btn-cancel:hover {
  background-color: #c9545e;
  color: #ffffff;
}
.rejectModal-form .modal-footer .footer-col button.btn-cancel i {
  font-size: 17px;
}
.reject-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.reject-modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.elementDisabled {
  color: grey;
}

.rejectModal-form .modal-colum ul li.elementDisabled:hover {
  background-color: white;
  color: grey;
}

.fixed-height {
  height: 217px;
}

.vertical-scroll {
  overflow-y: auto;
}

.rejectModal-modal {
  outline: none;
}

.btn.btn-link.no-border {
  border: none;
}

button.danger-outline:hover {
  background: #c9545e;
  color: #fff;
}

.validationMsg {
  font-size: 12px;
  font-weight: lighter;
  color: #c9545e;
}
</style>

<script>
import CustomTextArea from '@/components/common/CustomTextArea';
import CustomDropDown from '@/components/common/CustomDropDown';
import ActionButton from '@/components/common/ActionButton';
//import Title from "@/components/common/page/Title";
// import store from "@/store/index";
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Por favor, complete este campo.',
});
extend('selectone', {
  ...required,
  message: 'Por favor, seleccione una opción.',
});

export default {
  name: 'RejectEvaluationsModal',
  components: {
    CustomTextArea,
    CustomDropDown,
    ActionButton,
    //Title,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-plus',
        title: 'Evaluación No Aceptada',
      },
      visible: false,
      disabledDatesFrom: new Date(),
      errorMsgs: {
        comentario: 'El comentario es requerido (22126)',
        noAceptadaPor: 'Favor de seleccionar una opción',
      },
      errorMessage: '',
      rejectTypeId: null,
      rejectDescription: null,
      errors: [],
      evaluation: {
        rejectionById: null,
        rejectionComment: null,
      },
      selectedEvaluation: null,
    };
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    loadRejectTypes: {
      type: Boolean,
      default: true,
    },
    rejectTypeList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    rejectionById: {
      get() {
        if (this.evaluation.rejectionById != null) {
          let rejectionBy = this.rejectTypeList.find(
            (e) => e.id == this.evaluation.rejectionById
          );
          return rejectionBy;
        } else {
          return null;
        }
      },
      set(value) {
        this.evaluation.rejectionById = value.id;
      },
    },
  },
  methods: {
    clearEvaluationData() {
      this.evaluation.rejectionById = null;
      this.evaluation.rejectionComment = null;
    },
    clearFormAndData() {
      this.$refs.formValidator.reset();
      this.clearEvaluationData();
    },
    show(selectedEvaluation) {
      if (selectedEvaluation) {
        this.evaluation.rejectionById = selectedEvaluation.rejectionById;
        this.evaluation.rejectionComment = selectedEvaluation.rejectionComment;
        this.evaluation.studentEvaluationId =
          selectedEvaluation.studentEvaluationId;
      }
      this.visible = true;
    },
    hide() {
      this.clearFormAndData();
      this.visible = false;
    },
    getRejectEvaluationTypeList() {
      if (!this.loadRejectTypes || this.rejectTypeList.length > 0) {
        return;
      }
      this.$ApiGet(`/api/code/evaluationrejectiontypes`)
        .then((res) => {
          const list = res.data ? res.data : [];
          this.$emit('update:rejectTypeList', list);
        })
        .catch((err) => (this.response = err));
    },
    async saveRejectEvaluation(e) {
      e.preventDefault();
      const isValid = await this.$refs.formValidator.validate();
      if (isValid) {
        this.$emit('rejectEvaluationsSave', this.evaluation);
        //this.hide();

        this.$emit('state', true);
      }
    },
    cancelRejectEvaluation() {
      this.hide();
      this.$emit('rejectEvaluationsCancel');
    },
  },
  watch: {
    value(newValue) {
      this.selectedEvaluation = newValue;
      this.show(newValue);
    },
  },
  created() {
    this.getRejectEvaluationTypeList();
  },
  mounted() {
    this.selectedEvaluation = this.value;
    this.show(this.selectedEvaluation);
  },
};
</script>
